/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LoyaltyProgramSummaryV2Dto } from './loyaltyProgramSummaryV2Dto';


export interface UserLoyaltyV2Dto { 
    id?: number;
    cardNumber?: string;
    points?: number;
    precisePoints?: number;
    pointsToNextCoupon?: number;
    nextCouponName?: string;
    nextCouponImage?: string;
    maxAffordableCouponName?: string;
    maxAffordableCouponImage?: string;
    lastUpdate?: string;
    status?: UserLoyaltyV2Dto.StatusEnum;
    notificationsEnabled?: boolean;
    loyaltyProgram?: LoyaltyProgramSummaryV2Dto;
    availableCoupons?: number;
    companyCoupons?: number;
    activeCoupons?: number;
    activePromotions?: number;
    activeAnnouncements?: number;
}
export namespace UserLoyaltyV2Dto {
    export type StatusEnum = 'ACTIVE' | 'BLOCKED';
    export const StatusEnum = {
        Active: 'ACTIVE' as StatusEnum,
        Blocked: 'BLOCKED' as StatusEnum
    };
}


